import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[rbFabItem]'
})
export class RbFabItemDirective {

  constructor(private el:ElementRef) {
    this.el.nativeElement.style.margin = "6px"
  }

}
